'use strict';

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

define(['app', '$window', 'siteObj', 'cookie', '$console'], function (app, window, siteObj, cookie, $console) {

  var powerReviews = function powerReviews() {
    var component = {};
    var setupConfig = [];

    var _config = {
      reviewWrapperUrl: '/power-reviews.list?pr_return_url=' + window.location.origin + window.location.pathname,
      qaEnabled: false,
      schemaCategoryRemoval: false,
      product: 'product',
      list: 'list',
      home: 'dept',
      writeReview: 'writeReview',
      searchResults: 'search-results',
      subscribeChannels: {
        recentlyViewedInitialised: 'recentlyViewed/initialised',
        reviewStars: 'productReviewStars/update',
        powerReviewsReinitialise: 'powerReviews/reinitialise'
      },
      publishCount: 0,
      targetPublishCount: 1
    };

    var _selectors = {
      productDescription: '.productDescription_contentPropertyListItem_synopsis .athenaProductPageSynopsisContent',
      powerReviewsDisplay: '.productPage_powerReviewDisplay',
      powerReviewsQADisplay: '[data-component="powerReviewQADisplay"]',
      productVariations: '[data-product-variation]',
      productVariationOptions: '.athenaProductVariationsOption',
      productBlock: '.productBlock[data-product-id]',
      productRecentlyViewed: 'productRecentlyViewedProducts',
      aboveElementStory: '.stry-wrapper-footer',
      aboveElementPwr: '.p-w-r',
      schemaCategoryRemoval: '[data-schema-category-removal]'
    };

    var _init = function _init(element) {
      component.element = element;

      if (document.querySelector(component.selectors.powerReviewsQADisplay) || document.querySelector(component.selectors.powerReviewsQADisplay)) {
        component.config.qaEnabled = true;
      }

      if (document.querySelector(component.selectors.productRecentlyViewed)) {
        component.config.targetPublishCount = 2;
      }

      if (document.querySelector(component.selectors.schemaCategoryRemoval)) {
        component.config.schemaCategoryRemoval = true;
      }

      try {
        if (cookie.get('actualOptanonConsent') && cookie.get('actualOptanonConsent').includes('C0002') || window.cookieName === 'actualOptanonConsent' && window.cookieValue.includes('C0002')) {
          component.config.sm_data = 'ENABLED';
          component.config.enable_front_end_iovation_validation = true;
        } else {
          component.config.sm_data = 'DISABLED';
          component.config.enable_front_end_iovation_validation = false;
        }
      } catch (error) {
        $console.log('OneTrust not Found');
      }

      window.onload = function () {
        if (window.OneTrust !== undefined) {
          component.getCookieConsent();
        }
      };

      component.config.pageType = component.element.classList.contains(component.config.writeReview) ? component.config.writeReview : siteObj.type ? siteObj.type : siteObj.page;

      setupConfig = component.createConfig(siteObj.productID);

      component.subscribe();

      if (setupConfig) {
        window.pwr = window.pwr || function () {
          (pwr.q = pwr.q || []).push(arguments);
        };
        window.pwr('render', setupConfig);
      }
      return component;
    };

    var _createConfig = function _createConfig(sku) {
      switch (component.config.pageType) {
        case component.config.product:
          return component.createProductPageConfig(sku);
        case component.config.list:
        case component.config.home:
        case component.config.searchResults:
          return component.createListPageConfig();
        case component.config.writeReview:
          return component.createWriteReviewConfig();
        default:
          return null;
      }
    };

    var _subscribe = function _subscribe() {
      app.subscribe(component.config.subscribeChannels.recentlyViewedInitialised, function (sku) {
        component.config.publishCount++;

        if (component.config.publishCount === component.config.targetPublishCount) {
          component.unmountComponents();
          component.remountComponents(sku);
          component.config.publishCount = 0;
        }
      });

      app.subscribe(component.config.subscribeChannels.reviewStars, function (sku) {
        component.config.publishCount++;

        if (component.config.publishCount === component.config.targetPublishCount) {
          component.unmountComponents();
          component.remountComponents(sku);
          component.config.publishCount = 0;
        }
      });

      if (component.config.pageType === component.config.list || component.config.pageType === component.config.home || component.config.pageType === component.config.searchResults) {
        app.subscribe(component.config.subscribeChannels.powerReviewsReinitialise, function () {
          component.unmountComponents();
          component.remountComponents(siteObj.productID);
        });
      }
    };

    var _createProductPageConfig = function _createProductPageConfig(sku) {
      var powerReviewsElement = document.querySelector(component.selectors.powerReviewsDisplay);

      if (!powerReviewsElement) {
        return false;
      }

      var components = {
        ReviewSnapshot: 'pr-review-snapshot',
        ReviewImageDisplay: 'pr-review-image-display',
        ReviewList: 'pr-review-list',
        ReviewSnippet: 'pr-review-snippet-' + sku
      };

      if (component.config.qaEnabled) {
        components['QuestionSnippet'] = 'pr-qa-snippet-' + sku;
        components['QuestionDisplay'] = 'pr-qa-display-' + sku;
      }

      var feedlessProductData = component.createFeedlessProductData(sku);
      var externalSkuClass = document.querySelector('.externalSku');
      var groupingId = powerReviewsElement.getAttribute('data-option-groupingId');
      var externalSku = externalSkuClass ? externalSkuClass.getAttribute('data-external-sku') : '';
      var pageId = sku;

      if (externalSku !== '') {
        pageId = groupingId === '' ? externalSku : groupingId;
      }

      var wrapperUrl = component.config.reviewWrapperUrl;
      if (groupingId !== '') {
        wrapperUrl += '&pr_page_id_variant=' + externalSku + '&pr_page_id=' + groupingId;
      }

      var productConfig = [{
        enable_client_side_structured_data: false,
        enable_content_collection_modal: false,
        api_key: siteObj.powerReviews.apiKey,
        merchant_group_id: siteObj.powerReviews.merchantGroupId,
        merchant_id: siteObj.powerReviews.merchantId,
        locale: siteObj.customerLocale,
        page_id: pageId,
        enable_front_end_iovation_validation: component.config.enable_front_end_iovation_validation,
        sm_data: component.config.sm_data,
        components: components,
        on_change: component.onChange,
        on_back_to_top_click: function on_back_to_top_click() {

          var aboveElement = null;

          if (document.querySelector(component.selectors.aboveElementStory)) {
            aboveElement = document.querySelector(component.selectors.aboveElementStory);
          } else {
            aboveElement = document.querySelector(component.selectors.aboveElementPwr);
          }

          if (aboveElement) {
            aboveElement.scrollIntoView({ behavior: 'smooth' });
          }
        },
        review_wrapper_url: wrapperUrl,
        product: feedlessProductData.product
      }].concat(_toConsumableArray(component.createListPageConfig()));

      if (feedlessProductData.variants && feedlessProductData.variants.length > 0 && groupingId !== '') {
        productConfig[0].product.variants = feedlessProductData.variants;
      }

      return productConfig;
    };

    var _createWriteReviewConfig = function _createWriteReviewConfig() {
      return {
        api_key: siteObj.powerReviews.apiKey,
        merchant_group_id: siteObj.powerReviews.merchantGroupId,
        merchant_id: siteObj.powerReviews.merchantId,
        locale: siteObj.customerLocale,
        sm_data: component.config.sm_data,
        enable_front_end_iovation_validation: component.config.enable_front_end_iovation_validation,
        components: {
          Write: 'pr-write-review'
        },
        on_submit: function on_submit(config, data) {
          window.scrollTo(0, 0);
        }
      };
    };

    var _createListPageConfig = function _createListPageConfig() {
      var productList = document.querySelectorAll(component.selectors.productBlock);

      return [].concat(_toConsumableArray(productList)).map(function (product) {
        var productId = product.getAttribute('data-product-id');
        var snippetId = product.getAttribute('data-pr-snippet-id');
        var externalSku = product.getAttribute('data-external-sku');
        var groupingId = product.getAttribute('data-groupingId');
        var pageId = groupingId === '' ? externalSku : groupingId;

        if (groupingId === '' && externalSku === '') {
          pageId = productId;
        }

        var wrapperUrl = component.config.reviewWrapperUrl;
        if (groupingId !== '') {
          wrapperUrl += '&pr_page_id_variant=' + externalSku + '&pr_page_id=' + groupingId;
        }
        if (component.config.schemaCategoryRemoval) {
          return {
            api_key: siteObj.powerReviews.apiKey,
            merchant_group_id: siteObj.powerReviews.merchantGroupId,
            merchant_id: siteObj.powerReviews.merchantId,
            locale: siteObj.customerLocale,
            REVIEW_DISPLAY_SNAPSHOT_TYPE: "SIMPLE",
            ENABLE_CLIENT_SIDE_STRUCTURED_DATA: false,
            review_wrapper_url: wrapperUrl,
            page_id: pageId,
            sm_data: component.config.sm_data,
            enable_front_end_iovation_validation: component.config.enable_front_end_iovation_validation,
            components: {
              CategorySnippet: 'pr-category-snippet-' + snippetId
            }
          };
        }
        return {
          api_key: siteObj.powerReviews.apiKey,
          merchant_group_id: siteObj.powerReviews.merchantGroupId,
          merchant_id: siteObj.powerReviews.merchantId,
          locale: siteObj.customerLocale,
          REVIEW_DISPLAY_SNAPSHOT_TYPE: 'SIMPLE',
          review_wrapper_url: wrapperUrl,
          page_id: pageId,
          sm_data: component.config.sm_data,
          enable_front_end_iovation_validation: component.config.enable_front_end_iovation_validation,
          components: {
            CategorySnippet: 'pr-category-snippet-' + snippetId
          }
        };
      });
    };

    var _createFeedlessProductData = function _createFeedlessProductData(sku) {
      var selectedVariant = document.querySelector('.athenaProductVariationsOption[data-linked-product-id="' + sku + '"]');
      var powerReviewsElement = document.querySelector(component.selectors.powerReviewsDisplay);
      var productUrl = selectedVariant && selectedVariant.getAttribute('data-option-url') ? siteObj.siteURL + selectedVariant.getAttribute('data-option-url') : document.querySelector('link[rel="canonical"]').href;
      var inStock = selectedVariant && selectedVariant.getAttribute('data-option-oos') ? selectedVariant.getAttribute('data-option-oos') : powerReviewsElement.getAttribute('data-no-stock') !== 'true';
      var description = document.querySelector(component.selectors.productDescription) ? component.stripHtmlTags(document.querySelector(component.selectors.productDescription).innerHTML) : '';

      var variants = [];
      if (document.querySelector(component.selectors.productVariations)) {
        var variationsList = document.querySelectorAll(component.selectors.productVariationOptions);
        variationsList.forEach(function (variation) {
          var externalSku = variation.getAttribute('data-option-optionExternalSku');
          var idVariant = externalSku === '' ? variation.getAttribute('data-option-id') : externalSku;
          variants.push({
            name: variation.getAttribute('data-option-value'),
            image_url: variation.getAttribute('data-option-image'),
            upc: variation.getAttribute('data-option-barcode'),
            page_id_variant: idVariant
          });
        });
      }

      return {
        product: {
          name: selectedVariant && selectedVariant.getAttribute('data-option-value') ? selectedVariant.getAttribute('data-option-value') : siteObj.productTitle,
          url: productUrl,
          image_url: selectedVariant && selectedVariant.getAttribute('data-option-image') ? selectedVariant.getAttribute('data-option-image') : powerReviewsElement.getAttribute('data-image-url').replace('.com//', '.com/'),
          description: description,
          brand_name: siteObj.productBrand,
          upc: selectedVariant && selectedVariant.getAttribute('data-option-barcode') ? selectedVariant.getAttribute('data-option-barcode') : powerReviewsElement.getAttribute('data-option-barcode'),
          price: selectedVariant && selectedVariant.getAttribute('data-option-price') ? selectedVariant.getAttribute('data-option-price') : siteObj.productPrice.split(';')[1] || siteObj.productPrice,
          category_name: powerReviewsElement.getAttribute('data-option-category').replaceAll('/', '>'),
          in_stock: inStock
        },
        variants: variants
      };
    };

    var _unmountComponents = function _unmountComponents() {
      setupConfig.forEach(function (config) {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = Object.entries(config.components)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var _ref = _step.value;

            var _ref2 = _slicedToArray(_ref, 2);

            var _ = _ref2[0];
            var componentId = _ref2[1];

            window.pwr('unmount', componentId);
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      });
    };

    var _remountComponents = function _remountComponents(updatedSku) {
      setTimeout(function () {
        setupConfig = component.createConfig(updatedSku);
        window.pwr('render', setupConfig);
      }, 1000);
    };

    var _onChange = function _onChange(config, data) {
      if (config.component === 'ReviewList') {

        if (data.review_count > 0 && data.reviews.length > 0) {
          var reviews = [];
          var aggregateRating = {
            '@type': 'AggregateRating',
            'ratingValue': data.average_rating,
            'reviewCount': data.review_count
          };

          for (var i = 0; i <= data.reviews.length - 1; i++) {
            var pwrReview = data.reviews[i];
            var review = {
              '@type': 'Review',
              'name': pwrReview.details.headline,
              'description': pwrReview.details.comments,
              'datePublished': new Date(pwrReview.details.created_date).toISOString().split('T')[0],
              'author': {
                '@type': 'Person',
                'name': pwrReview.details.nickname
              },
              'reviewRating': {
                '@type': 'Rating',
                'ratingValue': pwrReview.metrics.rating
              }
            };
            reviews.push(review);
          }

          var scriptTag = document.getElementById('productSchema');
          var scriptTagObject = JSON.parse(scriptTag.innerHTML);
          scriptTagObject['aggregateRating'] = aggregateRating;
          scriptTagObject['review'] = reviews;
          scriptTag.innerHTML = JSON.stringify(scriptTagObject);
        }

        if (data.reviews.length === 0) {
          var _scriptTag = document.getElementById('productSchema');
          var _scriptTagObject = JSON.parse(_scriptTag.innerHTML);
          if (_scriptTagObject['review'] && _scriptTagObject['review'].length >= 1) {
            delete _scriptTagObject['review'];
          }
          _scriptTag.innerHTML = JSON.stringify(_scriptTagObject);
        }
      }
    };

    var _getCookieConsent = function _getCookieConsent() {
      OneTrust.OnConsentChanged(function () {
        if (OnetrustActiveGroups.includes('C0002')) {
          component.config.sm_data = 'ENABLED';
          component.config.enable_front_end_iovation_validation = true;
        } else {
          component.config.sm_data = 'DISABLED';
          component.config.enable_front_end_iovation_validation = false;
        }
        component.unmountComponents();
        component.remountComponents(siteObj.productID);
      });
    };

    var _stripHtmlTags = function _stripHtmlTags(str) {
      var html = new DOMParser().parseFromString(str, 'text/html');
      var sanitisedStr = html.body.textContent.replace(/<[^>]+>/g, '');

      return sanitisedStr.replace(/\s\s+/g, ' ') || '';
    };

    component.init = _init;
    component.config = _config;
    component.selectors = _selectors;
    component.subscribe = _subscribe;
    component.createConfig = _createConfig;
    component.createListPageConfig = _createListPageConfig;
    component.createProductPageConfig = _createProductPageConfig;
    component.createWriteReviewConfig = _createWriteReviewConfig;
    component.unmountComponents = _unmountComponents;
    component.remountComponents = _remountComponents;
    component.getCookieConsent = _getCookieConsent;
    component.createFeedlessProductData = _createFeedlessProductData;
    component.onChange = _onChange;
    component.stripHtmlTags = _stripHtmlTags;

    return component;
  };
  return powerReviews;
});
//# sourceMappingURL=powerReviews.js.map
